import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnAmberAlertVehicleType } from './amber-alert-vehicle-type';

export class SnAmberAlertPersonType extends SnModel {
  @Expose()
  public age: string;

  @Expose()
  public amberId: number;

  @Expose()
  public description: string;

  @Expose()
  public eyeColor: string;

  @Expose()
  public fullName: string;

  @Expose()
  public gender: string;

  @Expose()
  public hairColor: string;

  @Expose()
  public height: string;

  @Expose()
  public imageUrl: string;

  @Expose()
  public personType: string;

  @Expose()
  public skinColor: string;

  @Expose()
  public weight: string;

  @Expose()
  public vehicleList: SnAmberAlertVehicleType[];
}
